import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

import { Breadcrumb } from '../../../../components/Breadcrumb';
import { PageHeader } from '../../../../components/PageHeader';
import { createLocation } from '../../models';
import { getDisplayError } from '../../../../utils/get-display-error';
import { CreateLocationForm } from '../../components/CreateLocationForm';
import { PageHeading } from 'components/PageHeading';
import { captureException } from '@sentry/react';
import { trackEvent } from '../../../../utils/track-event';

const CreateLocationPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <PageHeader title="Nieuwe locatie" />

      <PageHeading
        leftSide={
          <Breadcrumb
            parentItem={{
              name: 'Locaties',
              to: '/internal/locations',
            }}
            currentItem="Nieuwe locatie"
          />
        }
      />

      <div className="px-4">
        <CreateLocationForm
          onSubmit={async (inputData) => {
            try {
              const result = await createLocation(inputData);
              trackEvent('location_created', {
                location_id: result.id,
                country: inputData.country,
              });
              navigate(`../${result.id}/general`, { replace: true });
              toast.success('Locatie aangemaakt');
            } catch (err: any) {
              captureException(err);
              toast.error('Kon locatie niet aanmaken: ' + getDisplayError(err));
            }
          }}
        />
      </div>
    </>
  );
};

export default CreateLocationPage;
